document.addEventListener("DOMContentLoaded", function() {
const atcButton = document.querySelector(".product-card__list-atc.btn.btn--primary.w-full");

  if (atcButton) {
    console.log("ATC button found!");
    // jis element se 'active' attribute hatana hai:
    const activeElement = document.querySelector("[active]");
    if (activeElement) {
      activeElement.removeAttribute("active");
      console.log("Removed 'active' attribute!");
    }
  }
  });
$(document).ready(function () {
  
  // Get short content (first 40 words + "Read more")
  function getShortContent(html,wordLimit='40') {
    var words = $('<div>').html(html).text().trim().split(/\s+/);
    if (words.length <= wordLimit) return html;
    return `${words.slice(0, wordLimit).join(' ')}... <span class="toggle read-more" style="cursor:pointer; user-select:none;"><u>Read more</u></span>`;
  }

  // Toggle content and handle clicks
  function toggleContent($content,wordLimit='40') {
    if (!$content.data('full')) {
      // First run: store full and short content
      var fullContent = $content.html().trim();
      var shortContent = getShortContent(fullContent,wordLimit);
      $content.data('full', fullContent).data('short', shortContent);
      $content.html(shortContent);
    } else if ($content.hasClass('expanded')) {
      // Show short content
      $content.html($content.data('short')).removeClass('expanded');
      $('html, body').animate({ scrollTop: $content.offset().top - 50 }, 300);
    } else {
      // Show full content with "Read less" inside a <p> tag
      var fullContent = $content.data('full').trim();
      $content.html(`${fullContent} <span class="toggle read-less" style="cursor:pointer; user-select:none;"><u>Read less</u></span>`)
              .addClass('expanded');
    }

    // Bind click to toggle buttons
    $content.find('.toggle').off('click').on('click', function () {
      toggleContent($content,wordLimit);
    });
  }

  // Check screen size and apply/remove "Read More"
  function handleResize() {
    $('tabs-component .page__tabcontent-jtpl.page__content .page__content-text').each(function () {
      var $content = $(this);
      var wordLimit = $(this).attr("data-truncate");
      // if (window.innerWidth <= 768) {
      //   toggleContent($content,wordLimit); // Apply on mobile
      // } else if ($content.data('full')) {
      //   $content.html($content.data('full')).removeClass('expanded'); // Show full on desktop
      // }
      if (window.innerWidth <= 768) {
  if (!$content.data('full')) {
    var fullContent = $content.html().trim();
    var shortContent = getShortContent(fullContent, wordLimit);
    $content.data('full', fullContent).data('short', shortContent);
    $content.html(shortContent);
    $content.find('.toggle').off('click').on('click', function () {
      toggleContent($content, wordLimit);
    });
  }
} else {
  if ($content.data('full')) {
    $content.html($content.data('full')).removeClass('expanded');
  }
}
    });
  }

  if( $('tabs-component .page__tabcontent-jtpl.page__content .page__content-text').length > 0){

  // Run on page load (with delay)
  setTimeout(handleResize, 300);

  // Run on resize (with 200ms delay)
  var resizeTimer;
  $(window).on('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(handleResize, 200);
  });
}

// for search result
$(document).on("click", ".search__results .cutombtnpop", function(e){
    e.preventDefault();
    // alert();
    console.log("<<<<<<<<<<<<<<<<<<<<<<btn clicked007>>>>>>>>>>>>>>>>>>>>>>>")
    var target = $(this).attr("data-target");
    console.log(`data target ${target}`);
    // $(".variant-modal__content").attr("aria-hidden", "true").removeClass("active");

    // Open the correct modal

       $(target)
      .attr("aria-hidden", "false")
      .addClass("active");
      $(".data-target").html("");

   

    console.log("========Variant modal opened:", target);
  });


  $(document).on("click", ".variant-modal__close", function(e){
    e.preventDefault();
    $(this).closest(".variant-modal__content")
      .attr("aria-hidden", "true")
      .removeClass("active");
  });
 // end code
});



